import styled from "@emotion/styled";
import { Typography } from "antd";
import { FC } from "react";
import { BankAllListResponse, bankingData } from "services/interface";
import moment from "moment";
import { numberFormat } from "utils/nuberFormat";

interface BanksInfoProps {
  data: bankingData | undefined;
}

const BanksInfo: FC<BanksInfoProps> = ({ data }) => {
  return (
    <>
      <ContentWrapper>
        <WrapperText>
          <Typography.Text style={{ color: "#A0A0A0" }}>
            บัญชีถูกสร้างเมื่อวันที่{" "}
          </Typography.Text>
          <Typography.Text style={{ fontWeight: 400 }}>
            {" "}
            {moment(data?.create_date).format("LL")}
          </Typography.Text>
        </WrapperText>
        <WrapperText>
          <Typography.Text style={{ color: "#A0A0A0" }}>
            คำสั่งซื้อทั้งหมด{" "}
          </Typography.Text>
          <Typography.Text style={{ fontWeight: 400 }}>
            {" "}
            {data?.order_count ?? 0} รายการ
          </Typography.Text>
        </WrapperText>
        {/* <WrapperText>
          <Typography.Text style={{ color: "#A0A0A0" }}>
            คำสั่งซื้อที่ยังไม่เสร็จสิ้น{" "}
          </Typography.Text>
          <Typography.Text style={{ fontWeight: 400 }}>
            {" "}
            0 รายการ
          </Typography.Text>
        </WrapperText> */}
        <WrapperText>
          <Typography.Text style={{ color: "#A0A0A0" }}>
            ยอดที่รับโอนรวมทั้งหมด{" "}
          </Typography.Text>
          <Typography.Text style={{ fontWeight: 400 }}>
            {" "}
            {numberFormat(data?.bank_paid_total ?? 0)} บาท
          </Typography.Text>
        </WrapperText>
      </ContentWrapper>
    </>
  );
};

export default BanksInfo;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 10px;
`;

const WrapperText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 5px;
  width: 100%;
  height: 100%;
`;




